import axios from 'axios';
import {url} from '../../../utils/urls';

const withCredentials = true;
const getAdminsPermissionsURL = `${url.embed.admin.url}/validate-permissions?permissions=newAdminPanel.csAdmin,newAdminPanel.csSuperAdmin`;
export const baseUrl = `${url.newAdminPanel.base}`;
export const sspManagerUrl = `${baseUrl}/apps/sspadstxt/sspmanager/sspslist`;
export const publisherAdsTxtUrl = `${baseUrl}/apps/sspadstxt/publishermanager/publisherslist`;

export const validateAdminPermissions = () => axios.get(`${getAdminsPermissionsURL}`, { withCredentials});